import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Database, objectVal, ref, update } from '@angular/fire/database';
import { map, Observable } from 'rxjs';
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root',
})
export class RespondentService {
  sEndpoint: string = 'https://apis.zenithr.net/api/';//http://localhost:52619/api/'https://apis.zenithr.net/api/';//

  constructor(private db: Database, private http: HttpClient, private globals: GlobalsService) {
    this.sEndpoint = this.globals.sEndpoint;
  }

  smsAuthTemplate(tenantKey: string, companyKey: string, surveyKey: string) {
    const authTemplate = {
      sender: 'Almarai',
      message:
        '#SENDER# has invited you to complete the Employee Engagement Survey below before #DEADLINE#. #SURVEYLINK#',
    };

    const path = `TenantData/${tenantKey}/SMSAuthorization/${companyKey}`;
    const dbRef = ref(this.db, path);

    return update(dbRef, authTemplate);
  }


  deleteSurveyRespondent(request) {
    return this.http.post(this.sEndpoint + 'Respondent/DeleteSurveyRespondent', request);
  }


  bulkDeleteRespondents(request) {
    return this.http.post(this.sEndpoint + 'Respondent/BulkDeleteSurveyRespondent', request);
  }


  bulkAddSurveyRespondent(request) {
    if (request.SurveyType == 'ASM')
      return this.http.post(this.sEndpoint + 'Assessment/BulkInsertSurveyRespondents', request);
    else if (request.SurveyType == 'ASM180')
      return this.http.post(this.sEndpoint + 'Assessment180/BulkInsertSurveyRespondents', request);
    else
      return this.http.post(this.sEndpoint + 'Respondent/BulkInsertSurveyRespondents', request);
  }

  getNumberOfRecordsToAdd(request) {
    return this.http.post(this.sEndpoint + 'Respondent/GetBulkSurveyRespondents', request);
  }


  deletePoolRespondent(request) {
    return this.http.post(this.sEndpoint + 'Respondent/DeletePoolRespondent', request);
  }


  bulkDeletePoolRespondent(request) {
    return this.http.post(this.sEndpoint + 'Respondent/BulkDeletePoolRespondent', request);
  }
  downloadHeatmap(request) {
    return this.http.post(this.sEndpoint + 'Respondent/DownloadHeatmap', request);
  }

  updateRespondentPool(request) {
    return this.http.post(this.sEndpoint + 'Respondent/UpdateRespondentPool', request);
  }

  fetchRespondentCount(request) {
    return this.http.post(this.sEndpoint + 'Respondent/GetNumberOfRespondents', request);
  }

  fetchPoolRespondent(request) {
    return this.http.post(this.sEndpoint + 'Respondent/FetchPoolRespondent', request);

  }

  validateCandidates(request) {
    if (request.SurveyType == 'ASM')
      return this.http.post(this.sEndpoint + 'Assessment/ValidateCandidates', request);
    else if (request.SurveyType == 'ASM180')
      return this.http.post(this.sEndpoint + 'Assessment180/ValidateCandidates', request);
  }
  updloadRespondents(request) {
    if (request.SurveyType == 'ASM')
      return this.http.post(this.sEndpoint + 'Assessment/UploadRespondents', request);
    else if (request.SurveyType == 'ASM180')
      return this.http.post(this.sEndpoint + 'Assessment180/UploadRespondents', request);
    else
      return this.http.post(this.sEndpoint + 'Respondent/UploadRespondents', request);
  }

  // Message for a failed Assessment upload (errorCode from the API); used as a translation key.
  uploadErrorMessage(response) {
    if (response?.errorCode == 'UPLOAD_IN_PROGRESS')
      return 'txt_Anotherup_303';
    if (response?.errorCode == 'CANDIDATE_NOT_FOUND')
      return 'txt_Thiscandi_639';
    return 'txt_Theupload_815';
  }

  updloadRespondentsCount(request) {
    return this.http.post(this.sEndpoint + 'Respondent/GetUploadRespondents', request);
  }

  downloadSurveyRespondents(request) {
    return this.http.post(this.sEndpoint + 'Respondent/DownloadSurveyRespondents', request);
  }


  fetchSurveyRespondets(request) {
    return this.http.post(this.sEndpoint + 'Respondent/FetchSurveyRespondets', request);
  }

  fetchPoolUpdates(tenantKey: string, companyKey: string): Observable<any> {
    const dbRef = ref(this.db, `/TenantData/${tenantKey}/RespondentListUpdates/${companyKey}`);
    return objectVal(dbRef).pipe(
      map((val: any) => ({ key: companyKey, ...val }))
    );
  }

  fetchSurveyStat(tenantKey: string, companyKey: string, engagementKey: string): Observable<any> {
    const dbRef = ref(this.db, `/TenantData/${tenantKey}/SurveyStats/${companyKey}/${engagementKey}`);
    return objectVal(dbRef).pipe(
      map((val: any) => ({ key: engagementKey, ...val }))
    );
  }

  fetchRespondentSurveyStats(request) {
    return this.http.post(this.sEndpoint + 'Respondent/FetchRespondentStats', request);
  }

  updateSurveyRespondent(request) {
    return this.http.post(this.sEndpoint + 'Respondent/UpdateSurveyRespondent', request);
  }

  fetchRespondentPool(request: { CompanyKey: string, TenantKey: string, pageNumber: number, pageSize: number, searchText: string }) {

    return this.http.post(`${this.sEndpoint}Respondent/FetchRespondentPool`, request);
  }

}
